<template>
    <div class="oma-volume-container">
       <span v-on:click="$emit('unmute')" class="oma-volume-button fa fa-volume-off" v-show="volume <= 0 || mute"></span>
       <span v-on:click="$emit('mute')" class="oma-volume-button fa fa-volume-down" v-show="volume <=50 && volume > 0 && !mute"></span>
       <span v-on:click="$emit('mute')" class="oma-volume-button fa fa-volume-up" v-show="volume>50 && !mute"></span>
       <span class="oma-volume-cursor-container">
         <input class="range" type="range" v-on:input="$emit('volume', $event.target.value)" :value="volume" />
       </span>
    </div>
</template>

<script>
export default {
    props: {
        volume: { type: Number, required: true},
        mute: {type: Boolean, required: true},
    },
    data: () => { return {
    }},
}
</script>

<style>
.oma-volume-button {
    cursor: pointer;
	background-repeat: no-repeat;
	background-size: cover;
	height:20px;
	width:20px;
}

.oma-volume-container {
    align-items: center;
    display: inline-flex;
    font-size: 1.3rem;
	width:300px;
}

.oma-volume-container input {
    background-color: transparent;
}

.oma-volume-cursor-container:before {
    content: "";
    background-color: currentColor;
    width: calc(100% - 6px);
    display: inline-block;
    height: 2px;
    position: absolute;
    align-self: center;
    margin-left: 3px;
    z-index: 0;
}

.oma-volume-cursor-container {
    line-height: 0;
    position: relative;
    display: flex;
	margin:0;
}

input.range {
    z-index: 1;
}

.fa-volume-off {
	background-image: url("@/assets/img/spkr-mute.svg");
}
.fa-volume-down {
	background-image: url("@/assets/img/spkr-low.svg");
}
.fa-volume-up {
	background-image: url("@/assets/img/spkr-full.svg");
}

</style>
